export default __webpack_public_path__ + "static/4-164bcc5596697bcc95ffacabdd1caa46.png";